import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../providers/Auth";
import { Container } from "./styles";

const Map = () => {
  const { initBattle } = useAuth();
  const token = localStorage.getItem("@game:accessToken") || "";
  const history = useHistory();
  const { leaderboard, getLeaderboard } = useAuth();

  useEffect(() => {
    getLeaderboard(token);
  }, [getLeaderboard, token]);

  return (
    <Container className="rpgui-content">
      <div className="a-droga-da-div-pai">
        <div className="levels ">
          {[0, 0, 0, 0, 0, 0, 0, 0, 0, 0].map((_, index) => (
            <button
              className={`rpgui-button ${index % 2 === 0 ? "par" : "impar"}`}
              type="button"
              onClick={() => initBattle(token, index + 1)}
            >
              <p>
                Stage {index * 10} - {(index + 1) * 10}
              </p>
            </button>
          ))}
        </div>
      </div>
      <button
        className="rpgui-button golden back-dash"
        onClick={() => history.push("/dashboard")}
      >
        <p>Dashboard</p>
      </button>
      <div className="rpgui-container framed-golden-2 leaderboard">
        <h3>Leaderboard</h3>
        <div className="chars-leaderboard">
          {leaderboard.map((char: any, index: any) => (
            <div
              key={char.id}
              className="rpgui-container framed-golden char-leaderboard"
            >
              <h1>
                {index + 1}- {char.name}
              </h1>
              <p>Level: {char.status.level}</p>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default Map;
